import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { ImageBroken } from '@phosphor-icons/react';

const StockPhotoImage = ({ sources, loading }) => {
  const [urlIndex, setUrlIndex] = useState(0);
  const [hasRetried, setHasRetried] = useState(false);
  const urls = sources.filter(
    (url, index, values) => url && values.indexOf(url) === index
  );
  const src = urls[urlIndex];

  useEffect(() => {
    if (src || !urls.length || hasRetried) return;
    // Retry transient image failures once without changing provider-signed URLs.
    const timer = window.setTimeout(() => {
      setHasRetried(true);
      setUrlIndex(0);
    }, 1000);
    return () => window.clearTimeout(timer);
  }, [src, urls.length, hasRetried]);

  return src ? (
    <img
      key={`${hasRetried}:${urlIndex}`}
      src={src}
      alt=''
      loading={loading}
      onError={() => setUrlIndex((index) => index + 1)}
    />
  ) : (
    <span className='photo-picker__image-unavailable' aria-hidden='true'>
      <ImageBroken size={24} />
    </span>
  );
};

StockPhotoImage.propTypes = {
  sources: PropTypes.arrayOf(PropTypes.string).isRequired,
  loading: PropTypes.oneOf(['eager', 'lazy'])
};

export default StockPhotoImage;
